import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';
import { HighchartsChartModule } from 'highcharts-angular';
import { CurrencyMaskInputMode, NgxCurrencyModule } from 'ngx-currency';
import { SharedModule } from '../_shared/shared.module';
import { GoogleMapModule } from '../google-map/google-map.module';
import { NavigationModule } from '../navigation/navigation.module';
import { CmaReportCardComponent } from './cma-report-card/cma-report-card.component';
import { CmaReportsFilterComponent } from './cma-reports-filter/cma-reports-filter.component';
import { CmaRoutingModule } from './cma-routing.module';
import { CmaComponent } from './cma.component';
import { ComparablesRecommendationsComponent } from './comparables-recommendations/comparables-recommendations.component';
import { CreateCmaReportComponent } from './create-cma-report/create-cma-report.component';
import { NetSellerComponent } from './net-seller/net-seller.component';
import { PropertyDetailsCardComponent } from './property-details-card/property-details-card.component';
import { PropertySearchAddressComponent } from './property-search-address/property-search-address.component';
import { PropertySearchListComponent } from './property-search-list/property-search-list.component';
import { PropertySearchComponent } from './property-search/property-search.component';
import { SchoolInfoDialogComponent } from './school-info-dialog/school-info-dialog.component';
import { ShareCmaReportDialogboxComponent } from './share-cma-report-dialogbox/share-cma-report-dialogbox.component';
import { ValueAdjustmentsComponent } from './value-adjustments/value-adjustments.component';
import { ViewCmaComparablesComponent } from './view-cma-comparables/view-cma-comparables.component';
import { ViewCmaMoreComponent } from './view-cma-more/view-cma-more.component';
import { ViewCmaPropertyDetailsComponent } from './view-cma-property-details/view-cma-property-details.component';
import { ViewCmaReportComponent } from './view-cma-report/view-cma-report.component';
import { ViewCmaSlideComponent } from './view-cma-slide/view-cma-slide.component';
import { ViewCmaTrendsComponent } from './view-cma-trends/view-cma-trends.component';
import { ViewCmaValuationComponent } from './view-cma-valuation/view-cma-valuation.component';


export const customCurrencyMaskConfig = {
  align: 'left',
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 0,
  prefix: '',
  suffix: '',
  thousands: ',',
  nullable: true,
  min: 0,
  max: null,
  inputMode: CurrencyMaskInputMode.NATURAL,
};

@NgModule({
  declarations: [
    PropertySearchComponent,
    CmaComponent,
    CreateCmaReportComponent,
    CmaReportCardComponent,
    CmaReportsFilterComponent,
    ViewCmaReportComponent,
    PropertySearchListComponent,
    PropertyDetailsCardComponent,
    PropertySearchAddressComponent,
    ViewCmaPropertyDetailsComponent,
    ViewCmaComparablesComponent,
    ViewCmaValuationComponent,
    ViewCmaTrendsComponent,
    ViewCmaMoreComponent,
    ShareCmaReportDialogboxComponent,
    SchoolInfoDialogComponent,
    ViewCmaSlideComponent,
    ComparablesRecommendationsComponent,
    NetSellerComponent,
    ValueAdjustmentsComponent,
  ],
  exports: [CmaReportCardComponent, ShareCmaReportDialogboxComponent],
  imports: [
    MatBadgeModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSliderModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatTableModule,
    MatTabsModule,
    NavigationModule,
    CmaRoutingModule,
    ReactiveFormsModule,
    MatCardModule,
    MatTooltipModule,
    MatRadioModule,
    MatDialogModule,
    SharedModule,
    NgxGalleryModule,
    HighchartsChartModule,
    GoogleMapModule,
    MatStepperModule,
    MatExpansionModule,
    NgxCurrencyModule.forRoot(customCurrencyMaskConfig),
    MatButtonToggleModule,
  ],
})
export class CmaModule { }
